var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtfModalCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.20825C4.75 6.96942 4.75 5.84921 5.44588 5.15413C6.14096 4.45825 7.26117 4.45825 9.5 4.45825H11.875C14.1138 4.45825 15.234 4.45825 15.9291 5.15413C16.625 5.84921 16.625 6.96942 16.625 9.20825V13.1666C16.625 15.4054 16.625 16.5256 15.9291 17.2207C15.234 17.9166 14.1138 17.9166 11.875 17.9166H9.5C7.26117 17.9166 6.14096 17.9166 5.44588 17.2207C4.75 16.5256 4.75 15.4054 4.75 13.1666V9.20825Z",
    stroke: "#FFEE00",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.75 15.5416C4.12011 15.5416 3.51602 15.2914 3.07062 14.846C2.62522 14.4006 2.375 13.7965 2.375 13.1666V8.41658C2.375 5.43121 2.375 3.93813 3.30283 3.01109C4.23067 2.08404 5.72296 2.08325 8.70833 2.08325H11.875C12.5049 2.08325 13.109 2.33347 13.5544 2.77887C13.9998 3.22427 14.25 3.82836 14.25 4.45825",
    stroke: "#FFEE00",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtfModalCopyIcon);
export default __webpack_public_path__ + "static/media/ftf_modal_copy_icon.4315b52c5024ee52f72864ee5ac97146.svg";
export { ForwardRef as ReactComponent };